import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import {Button, LoadingIndicator} from '../../../components'
import {Container, Title, Link, Selector, Calendar, SimpleSelector} from '../../flow'
import Costs from '../containers/costs'
import moment from '../../../common/moment'
import {calendar as text} from '../text'
import {formatAddress} from '../../../common/format'
import {PRICES_AVAILABLE} from "../../../App"

const styles = (theme) => ({
  container: {maxWidth: 328, margin: '0 auto'},
  title: {marginBottom: 20},
  link: {textAlign: 'right', marginTop: 10, marginBottom: 30},
  simpleSelector: {margin: '30px 0'},
  button: {margin: '5px 0'},
})

class CalendarStep extends React.Component {

  static displayName = 'CalendarStep.component'

  state = {
    openAddress: false,
    timeslotError: false,
  }

  componentDidMount() {
    this.props.updateUrl()
  }

  setOpenAddress = (open) => this.setState({openAddress: open})

  onSelectAddress = (id) => {
    this.setOpenAddress(false)
    this.props.selectAddress(id)
  }

  onSelectTimeslot = (id) => {
    this.setState({timeslotError: false})
    this.props.selectTimeslot(id)
  }

  onContinue = () => {
    if (this.props.timeslotSelected === 0) {
      this.setState({timeslotError: true})
    } else {
      this.props.continue()
    }
  }

  render() {
    const {classes} = this.props
    return (
      <Container className={classes.container}>
        <Costs/>
        <Title className={classes.title}>{text.whenDoWePickItUp}</Title>
        <Selector
          defaultLabel={text.noAddressSelected}
          title={text.address}
          open={this.state.openAddress}
          onClose={() => this.setOpenAddress(false)}
          onOpen={() => this.setOpenAddress(true)}
          onCancel={() => this.setOpenAddress(false)}
          onSelect={this.onSelectAddress}
          options={this.props.addresses.map(a => ({
            label: formatAddress(a.Address, a.Number, a.Floor, a.Apartment, ''),
            value: a.ID,
            disabled: a.InDeliveryRange === false,
          }))}
          value={this.props.addressSelected}
          isLoading={this.props.isAddressLoading}
        />
        <div className={classes.link}>
          <Link onClick={this.props.goToAddress}>{text.newAddress}</Link>
        </div>
        <Calendar
          mode={'single'}
          disabledDates={this.props.unavailableDates}
          minDate={moment().add(-1, 'day')}
          maxDate={moment().add(90, 'day')}
          onClick={(date) => this.props.selectDate(date)}
          isLoading={this.props.isCalendarLoading}
        />
        <SimpleSelector
          title={text.time}
          className={classes.simpleSelector}
          value={this.props.timeslotSelected}
          onSelect={this.onSelectTimeslot}
          options={this.props.timeslots.map(t => ({
            label: t.get('Hour') + ':' + pad(t.get('Minute')),
            value: t.get('ID'),
            disabled: false,
          }))}
          disabled={this.props.dateSelected === null || this.props.timeslots.length === 0}
          isLoading={this.props.isTimeSlotLoading}
          error={this.state.timeslotError}
        />
        {PRICES_AVAILABLE &&
          <Button
            variant={'secondary'}
            fullWidth={true}
            className={classes.button}
            onClick={this.props.openCosts}
          >
            {text.prices}
          </Button>
        }
        <LoadingIndicator show={this.props.isButtonLoading}>
          <Button
            variant={'primary'}
            fullWidth={true}
            className={classes.button}
            onClick={this.onContinue}
            disabled={this.props.isButtonDisabled}
          >
            {text.continue}
          </Button>
        </LoadingIndicator>
      </Container>
    )
  }

  static propTypes = {
    dateSelected: PropTypes.object,
    unavailableDates: PropTypes.array,
    selectDate: PropTypes.func.isRequired,
    timeslots: PropTypes.array,
    timeslotSelected: PropTypes.number,
    selectTimeslot: PropTypes.func.isRequired,
    setStep: PropTypes.func.isRequired,
    isCalendarLoading: PropTypes.bool,
    isTimeSlotLoading: PropTypes.bool,
    isAddressLoading: PropTypes.bool,
    error: PropTypes.string,
    selectAddress: PropTypes.func.isRequired,
    addressSelected: PropTypes.number,
    addresses: PropTypes.array,
    continue: PropTypes.func,
    isButtonLoading: PropTypes.bool,
    isButtonDisabled: PropTypes.bool,
    openCosts: PropTypes.func.isRequired,
    goToAddress: PropTypes.func.isRequired,
    updateUrl: PropTypes.func.isRequired,
  }
}

export default withStyles(styles, {withTheme: true})(CalendarStep)

function pad(string) {
  const str = '' + string
  const pad = '00'
  return pad.substring(0, pad.length - str.length) + str
}



// WEBPACK FOOTER //
// ./src/sections/depositV2/components/calendar.step.jsx